import { RECAPTCHA_PUBLIC_KEY } from "./Constants";

export default function () {

    if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_RECAPTCHA_TOKEN) {
        return window.Promise.resolve(process.env.REACT_APP_RECAPTCHA_TOKEN);
    }
    return new window.Promise((resolve, reject) => {
        window.grecaptcha.ready(async function () {
            try {
                window.grecaptcha
                    .execute(RECAPTCHA_PUBLIC_KEY, { action: 'submit' })
                    .then(resolve);
            } catch (e) {
                reject(e);
            }
        });
    });

}


// WEBPACK FOOTER //
// ./src/common/RecaptchaTokenResolver.js